import * as THREE from 'three'
import { fromLatLon } from 'utm'
import { Location } from './openapi'

export const CreatePositionVectorFromLatLon = (
  geoPosition: Location,
  utmzone: number,
  aabb: THREE.Box3,
  origin: THREE.Vector2
) => {
  const position = new THREE.Vector3()
  const geopos = fromLatLon(geoPosition.latitude, geoPosition.longitude, utmzone)
  position.x = geopos.easting - origin.x
  position.y = origin.y - geopos.northing
  position.z = aabb.max.y + 10
  return position
}

export const CreateAabb = (scene_: THREE.Scene) => {
  const aabb = new THREE.Box3()
  aabb.setFromObject(scene_)
  return aabb
}
